// extracted by mini-css-extract-plugin
export var iconContainer = "_b2-0";
export var metricCardsContainer = "_b2-1";